export default __webpack_public_path__ + "files/af9b6341b25687bd266ae48515c11e04.svg";